export const OUTCOMES = {
    created: { label: "New leads created", short: "New lead created", tone: "emerald" },
    existing_added: { label: "Existing leads added", short: "Existing lead added", tone: "sky" },
    existing_review: { label: "Existing-lead matches awaiting review", short: "Existing lead to review", tone: "amber" },
    duplicate_skipped: { label: "Duplicates skipped", short: "Duplicate skipped", tone: "slate" },
    shared_phone_conflict: { label: "Shared-phone conflicts", short: "Shared-phone conflict", tone: "orange" },
    invalid_phone: { label: "Invalid phones", short: "Invalid phone", tone: "rose" },
    invalid_row: { label: "Invalid rows", short: "Invalid row", tone: "rose" },
    failed: { label: "Failed rows", short: "Failed", tone: "red" },
};

export const FILTERS = [
    ["issues", "All Issues"],
    ["existing_review", "Existing Leads to Review"],
    ["existing_added", "Existing Leads Added"],
    ["duplicate_skipped", "Duplicates Skipped"],
    ["shared_phone_conflict", "Shared-Phone Conflicts"],
    ["invalid_phone", "Invalid Phones"],
    ["invalid_row", "Invalid Rows"],
    ["failed", "Failed Rows"],
    ["created", "New Leads Created"],
];

export const TONE = {
    emerald: "bg-emerald-50 border-emerald-200 text-emerald-800",
    sky: "bg-sky-50 border-sky-200 text-sky-800",
    amber: "bg-amber-50 border-amber-200 text-amber-900",
    slate: "bg-slate-50 border-slate-200 text-slate-800",
    orange: "bg-orange-50 border-orange-200 text-orange-800",
    rose: "bg-rose-50 border-rose-200 text-rose-800",
    red: "bg-red-50 border-red-200 text-red-800",
};

const plural = (n, one, many) => `${(n || 0).toLocaleString()} ${n === 1 ? one : many}`;

// One-line summary from the import totals (used where only batch counts are available).
export const basicSummary = (c) => [
    plural(c.imported, "new lead created", "new leads created"),
    plural(c.duplicates, "matched or skipped", "matched or skipped"),
    plural(c.invalidPhones, "invalid phone", "invalid phones"),
    plural(c.invalid, "invalid row", "invalid rows"),
    plural(c.failed, "failed", "failed"),
].join(" · ");
